<template>
<div class="chapter">
<div class="inner_page">
<p class="htitle"><span><span epub:type="pagebreak" id="page_vii" title="vii">Our Daily Poison</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Halftitle1.vue?d350998c